const Style = {

  onboarding: 'flex min-h-full items-center justify-center bg-gradient-to-br from-[#FFD84D] via-[#FFB800] to-[#F0B300] px-3 text-left'

}

export default Style;
